<template>
  <div class="terms-checkbox mt-4 mb-6">
    <label class="flex items-start">
      <input
        type="checkbox"
        :value="value"
        @input="$emit('input', $event.target.checked)"
        class="mr-3 h-5 w-5 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
      />
      <span class="text-sm text-gray-700">
        {{ labelText }} 
        <a
          :href="link"
          target="_blank"
          rel="noopener noreferrer"
          class="text-blue-600 hover:text-blue-800 underline"
        >
          {{ linkText }}
        </a>
      </span>
    </label>

    <slot name="errors"></slot>
  </div>
</template>

<script>
export default {
  name: 'TermsCheckbox',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    labelText: {
      type: String,
      required: true,
    },
    linkText: {
      type: String,
      required: true,
    },
    link: {
      type: String,
      required: true,
    },
  },
};
</script>


<style lang="scss" scoped>
.terms-checkbox {
  .error {
    display: none;
    left: 0;
    opacity: 0;
    -webkit-transform: translate3d(0, -8px, 0);
    transform: translate3d(0, -8px, 0);
    font-size: 0.85rem;
  }
  &.invalid .error {
    opacity: 1;
    margin-top: 12px;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    background: #fbeeca;
    font-weight: bold;
    padding: 14px;
    padding-left: 55px;
    margin-bottom: 10px;
    display: flex !important;
    align-items: center;

    &:before {
      content: '';
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-info'%3E%3Ccircle cx='12' cy='12' r='10'%3E%3C/circle%3E%3Cline x1='12' y1='16' x2='12' y2='12'%3E%3C/line%3E%3Cline x1='12' y1='8' x2='12.01' y2='8'%3E%3C/line%3E%3C/svg%3E");
      padding-bottom: 6px;
      font-size: 16px;
      position: absolute;
      width: 25px;
      height: 25px;
      left: 16px;
      display: flex;
      justify-content: center;
      align-items: center;
      line-height: 1;
    }
  }
}
</style>
